import React from 'react';

import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core';

import { markdownToHtml } from '@vyce/core/src/utils/simpleMarkdown';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& strong': {
        fontWeight: 700,
      },
      '& em, & i': {
        fontStyle: 'italic',
      },
      '& br': {
        display: 'block',
        content: '""',
        marginTop: 4,
      },
    },
  })
);

interface Props {
  text?: string | null;
  variant?: 'body1' | 'body2' | 'caption';
}

/**
 * Renders description text with simple rich formatting (bold **, italic *, newlines).
 * Use for form.description and similar rich text fields.
 */
export const FormattedDescription: React.FC<Props> = ({ text, variant = 'body1' }) => {
  const classes = useStyles();
  const theme = useTheme();

  const trimmed = text?.trim();
  if (!trimmed) {
    return null;
  }

  const html = markdownToHtml(trimmed);
  const fontSize = variant === 'caption' ? 12 : variant === 'body2' ? 14 : 16;

  return (
    <div
      className={classes.root}
      style={{
        fontSize,
        color: theme.palette.text.secondary,
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
